import { isOlderthan18 } from "src/helpers/addCase";
import * as yup from "yup";

const spaceCheckYupValidation = (val?: string) =>
  val ? !/^\s*$/.test(val) : false;

export const AddCaseSchema = yup.object({
  mos: yup.string().required(),
  submission_source: yup.string().required(),
  user_id: yup.number().required(),
  creator_name: yup.string().required(),
  doctor_firstlastname: yup.string(),
  doctor_fullname: yup.string(),
  patient_firstlastname: yup.string(),
  patient_fullname: yup.string(),
  patient_dob: yup.string(),
  practice_name: yup.string(),
  original_id: yup.number(),
  category: yup.string().required(),
  api_pa_approved: yup.boolean(),
  // uploaded_documents: yup
  //   .array()
  //   .of(yup.mixed().required())
  //   .when(["api_pa_approved", "case_attributes"], {
  //     is: (
  //       api_pa_approved?: boolean,
  //       case_attributes?: { pa_approved: string }
  //     ) => {
  //       return process.env.REACT_APP_ENV === "staging"
  //         ? api_pa_approved ||
  //           (case_attributes && case_attributes.pa_approved?.length > 0)
  //           ? false
  //           : true
  //         : false;
  //     },
  //     then: (schema) =>
  //       schema
  //         .min(1, "Prescription document is required")
  //         .required("Prescription document is required"),
  //     otherwise: (schema) => schema.notRequired(),
  //   }),
  prescription_attributes: yup
    .object({
      condition: yup.string().required("Patient Diagnosis is required "),
      drug_name: yup.string().required(),
      diagnosis_code: yup
        .array()
        .of(yup.string().required(`Diagnosis code is required`))
        .min(1, `Diagnosis code is required`)
        .required(`Diagnosis code is required`),
      direction: yup
        .string()
        .max(255, "Direction should only be 255 characters long")
        .when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema.test(
              "whiteSpaceRemoval",
              "Direction should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
        }),
      note: yup
        .string()
        .max(350, "Note should only be 350 characters long")
        .when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema.test(
              "whiteSpaceRemoval",
              "Note should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
        }),
        Patient_training_required:yup.boolean(),
      // refills_authorized: yup
      //   .number()
      //   .typeError("Enter a number between 0 and 12")
      //   .when({
      //     is: (val: string) => (val && typeof val === "number" ? true : false),
      //     then: (schema) =>
      //       schema
      //         .test(
      //           "whiteSpaceRemoval",
      //           "Enter a number between 0 and 12",
      //           (val) =>
      //             val && spaceCheckYupValidation(val.toString()) ? true : false
      //         )
      //         .test(
      //           "checkNumberInRange",
      //           "Enter a number between 0 and 12",
      //           (val) => {
      //             if (val && typeof val === "number") {
      //               if (!isNaN(val)) {
      //                 if (val > 0 && val < 13) return true;
      //               }
      //               return false;
      //             } else {
      //               return true;
      //             }
      //           }
      //         ),
      //   }),
      written_date: yup.string().required(),
      // quickstart: yup.boolean().required(),
      packaging_size: yup.string().required("Package Size is required"),
      qty: yup.string().required("Quantity is required"),
      quantity: yup.number(),
      days_supply: yup.string().matches(/^[0-9]+$/, { message: "Days Supply must contain only numbers", excludeEmptyString: true }).optional(),
      number_of_boxes: yup
        .number()       
        .typeError("Number of Boxes is required")
        .required("Number of Boxes is required")
        .integer("Only whole numbers allowed")
        .moreThan(0, "Number of Boxes must be greater than 0")
        .max(99, "Maximum two digits allowed"),
    })
    .required(`prescription attributes are required`),

  prescription_information_attributes: yup
    .object({
      packaging_size: yup.string(),
      quantity: yup.number(),
      min_inhale_units: yup
        .string()
        .required("Minimum Inhale is required")
        .test("min-inhale-positive", "Minimum Inhale cannot be less than zero", (value) => !value || (Number.isFinite(Number(value)) && Number(value) >= 0))
        .test(
          "min-inhale-range", 
          "Minimum Inhale cannot be greater than or equal to Maximum Inhale", 
          (value, context) => !value || !context.parent.max_inhale_units || Number(value) < Number(context.parent.max_inhale_units)
        ),
      max_inhale_units: yup
        .string()
        .required("Maximum Inhale is required")
        .test("max-inhale-positive", "Maximum Inhale cannot be less than zero", (value) => !value || (Number.isFinite(Number(value)) && Number(value) >= 0))
        .test(
          "max-inhale-range", 
          "Maximum Inhale cannot be smaller than or equal to Minimum Inhale", 
          (value, context) => !value || !context.parent.min_inhale_units || Number(value) > Number(context.parent.min_inhale_units)
        ),
      additional_units: yup.string().required("Use additional is required"),
      total_daily_units: yup.string().required("Max Daily Dose is required"),
      refills: yup.string().required("# of Refills is required"),
      cp_diuretics: yup
        .object({
          diuretics_tried: yup
            .object({
              other: yup.boolean(),
              other_props: yup.object({
                other_name: yup.string(),
                other_failure_reason: yup.string(),
                other_failure_reason_other: yup.string(),
                other_tried_date: yup.string(),
              }),
              novolog: yup.boolean(),
              novolog_props: yup.object({
                novolog_failure_reason: yup.string(),
                novolog_failure_reason_other: yup.string(),
                novolog_tried_date: yup.string(),
              }),
              novolin: yup.boolean(),
              novolin_props: yup.object({
                novolin_failure_reason: yup.string(),
                novolin_failure_reason_other: yup.string(),
                novolin_tried_date: yup.string(),
              }),
              humalog: yup.boolean(),
              humalog_props: yup.object({
                humalog_failure_reason: yup.string(),
                humalog_failure_reason_other: yup.string(),
                humalog_tried_date: yup.string(),
              }),
              humulin: yup.boolean(),
              humulin_props: yup.object({
                humulin_failure_reason: yup.string(),
                humulin_failure_reason_other: yup.string(),
                humulin_tried_date: yup.string(),
              }),
              fiasp: yup.boolean(),
              fiasp_props: yup.object({
                fiasp_failure_reason: yup.string(),
                fiasp_failure_reason_other: yup.string(),
                fiasp_tried_date: yup.string(),
              }),
              lyumjev: yup.boolean(),
              lyumjev_props: yup.object({
                lyumjev_failure_reason: yup.string(),
                lyumjev_failure_reason_other: yup.string(),
                lyumjev_tried_date: yup.string(),
              }),
              aspart: yup.boolean(),
              aspart_props: yup.object({
                aspart_failure_reason: yup.string(),
                aspart_failure_reason_other: yup.string(),
                aspart_tried_date: yup.string(),
              }),
              lispro: yup.boolean(),
              lispro_props: yup.object({
                lispro_failure_reason: yup.string(),
                lispro_failure_reason_other: yup.string(),
                lispro_tried_date: yup.string(),
              }),
              apidra: yup.boolean(),
              apidra_props: yup.object({
                apidra_failure_reason: yup.string(),
                apidra_failure_reason_other: yup.string(),
                apidra_tried_date: yup.string(),
              }),
              admelog: yup.boolean(),
              admelog_props: yup.object({
                admelog_failure_reason: yup.string(),
                admelog_failure_reason_other: yup.string(),
                admelog_tried_date: yup.string(),
              }),
              u200: yup.boolean(),
              u200_props: yup.object({
                u200_failure_reason: yup.string(),
                u200_failure_reason_other: yup.string(),
                u200_tried_date: yup.string(),
              }),
              u500: yup.boolean(),
              u500_props: yup.object({
                u500_failure_reason: yup.string(),
                u500_failure_reason_other: yup.string(),
                u500_tried_date: yup.string(),
              }),
              two_orals_anti_diabetics: yup.boolean(),
              two_orals_anti_diabetics_props: yup.object({
                two_orals_anti_diabetics_failure_reason: yup.string(),
                two_orals_anti_diabetics_failure_reason_other: yup.string(),
                two_orals_anti_diabetics_tried_date: yup.string(),
              }),
            })
            .test("med-required-fields", "", function (value) {
              if (!value) return true;
              const meds = [
                "other",
                "novolog",
                "novolin",
                "humalog",
                "humulin",
                "fiasp",
                "lyumjev",
                "aspart",
                "lispro",
                "apidra",
                "admelog",
                "u200",
                "u500",
                "two_orals_anti_diabetics",
              ];
              const errors: yup.ValidationError[] = [];
              const today = new Date();
              today.setHours(23, 59, 59, 999);

              for (const med of meds) {
                if ((value as any)[med]) {
                  const props = (value as any)[`${med}_props`];
                  const reason = props?.[`${med}_failure_reason`];
                  const date = props?.[`${med}_tried_date`];
                  const reasonOther = props?.[`${med}_failure_reason_other`];

                  if (
                    med === "other" &&
                    (!props?.other_name || /^\s*$/.test(props.other_name))
                  ) {
                    errors.push(
                      new yup.ValidationError(
                        "Please specify the treatment name",
                        props?.other_name,
                        `${this.path}.other_props.other_name`,
                      ),
                    );
                  }

                  if (!reason) {
                    errors.push(
                      new yup.ValidationError(
                        "Failure reason is required",
                        reason,
                        `${this.path}.${med}_props.${med}_failure_reason`,
                      ),
                    );
                  }

                  if (!date) {
                    errors.push(
                      new yup.ValidationError(
                        "Date tried is required",
                        date,
                        `${this.path}.${med}_props.${med}_tried_date`,
                      ),
                    );
                  } else if (new Date(date) > today) {
                    errors.push(
                      new yup.ValidationError(
                        "Date tried cannot be a future date",
                        date,
                        `${this.path}.${med}_props.${med}_tried_date`,
                      ),
                    );
                  }

                  if (
                    reason === "Other" &&
                    (!reasonOther || /^\s*$/.test(reasonOther))
                  ) {
                    errors.push(
                      new yup.ValidationError(
                        "Please specify the failure reason",
                        reasonOther,
                        `${this.path}.${med}_props.${med}_failure_reason_other`,
                      ),
                    );
                  }
                }
              }

              if (errors.length === 0) return true;
              throw new yup.ValidationError(errors);
            }),
        })
        .nullable()
        .required(),
    })
    .required(`prescription Information are required`),

  patient_attributes: yup
    .object({
      global_patient_id: yup
        .number()
        .default(0)
        .required(`Patient is required`),
      title: yup.string(),
      firstname: yup
        .string()
        .required("First name is required")
        .max(35, "First name should only be 35 characters long")
        .test(
          "whiteSpaceRemoval",
          "First name should not contain only spaces",
          (val) => spaceCheckYupValidation(val),
        ),
      middlename: yup
        .string()
        .max(35, "Middle name should only be 35 characters long")
        .when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema.test(
              "whiteSpaceRemoval",
              "Middle name should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
        }),
      lastname: yup
        .string()
        .required("Last name is required")
        .max(35, "Last name should only be 35 characters long")
        .test(
          "whiteSpaceRemoval",
          "Last name should not contain only spaces",
          (val) => spaceCheckYupValidation(val),
        ),
      dob: yup
        .string()
        .required("DOB is required")
        .test(
          "dates-test",
          "Date of Birth should be less than present date",
          (value: string) => {
            const dob = new Date().toISOString().substring(0, 10);
            return dob >= value;
          },
        ),
      weight: yup.string(),
      // .when("dob", {
      //   is: (dob?: string) => {
      //     if (dob) {
      //       if (!isOlderthan18(dob)) return true;
      //       else return false;
      //     } else return false;
      //   },
      //   then: (schema) =>
      //     schema
      //       .test(
      //         "isEmptyWeight",
      //         "Weight is required for patient’s under 18 years",
      //         (weight?: string) => {
      //           if (
      //             weight &&
      //             (weight.includes("kg") || weight.includes("lb"))
      //           ) {
      //             const parsedWeight = weight.replace(/(kg|lb)$/, "");
      //             if (parsedWeight.length === 0) return false;
      //             else return true;
      //           } else return false;
      //         }
      //       )
      //       .test("isValidWeight", "Weight is invalid", (weight?: string) => {
      //         const weightValue = weight?.replace(/(kg|lb)$/, "");
      //         if (!isNaN(Number(weightValue))) {
      //           if (Number(weightValue) > 0)
      //             return /^\d+(\.\d{1})?$/.test(weightValue || "0");
      //           else return false;
      //         } else return false;
      //       }),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      // patient_email_id: yup.number().required().nullable(),
      // patient_email: yup
      //   .string()
      //   .when({
      //     is: (val: string) => val && val.length > 0,
      //     then: (schema) => schema
      //       .max(70, "Email should only be 70 characters long")
      //       .test("isEmailValid", "Email should be a valid email", (val?: string) => val && EMAIL_REGEX.test(val) ? true : false)
      //   }),
      gender: yup.string().required("Gender is required"),
      caregiver_name: yup.string().when("dob", {
        is: (dob?: string) => {
          if (dob) {
            if (!isOlderthan18(dob)) return true;
            else return false;
          } else return false;
        },
        then: (schema) =>
          schema.trim().required("Parent/Guardian name is required"),

        otherwise: (schema) => schema.notRequired(),
      }),
      // caregiver_phone_number: yup
      //   .string()
      //   // .min(10, `Phone number invalid`)
      //   // .max(10, `Phone number invalid`)
      //   .test('range', 'Phone number invalid', (val?: string) => {
      //     if (val && val.length > 0) {
      //       const numberedVal = Number(val)
      //       if (!isNaN(numberedVal)) {
      //         if (numberedVal > 2000000000 && numberedVal < 9999999999) return true;
      //       }
      //       return false;
      //     } else {
      //       return true;
      //     }
      //   }),
      caregiver_phone_number: yup
        .string()

        .when("dob", {
          is: (dob?: string) => {
            if (dob) {
              if (!isOlderthan18(dob)) return true;
              else return false;
            } else return false;
          },
          then: (schema) =>
            schema
              .required("Parent/Guardian phone number is required")
              .test("range", "Phone number invalid", (val?: string) => {
                if (val && val.length > 0) {
                  const numberedVal = Number(val);
                  if (!isNaN(numberedVal)) {
                    if (numberedVal > 2000000000 && numberedVal < 9999999999)
                      return true;
                  }
                  return false;
                } else {
                  return true;
                }
              }),
          otherwise: (schema) => schema.notRequired(),
        }),
      best_time_to_contact: yup.string(),

      phone_numbers: yup
        .array()
        .of(
          yup.object({
            phone_type: yup.string().required("Phone type is required"),
            number: yup
              .string()
              .required(`Phone number is required`)
              .min(10, `Phone number invalid`)
              .max(10, `Phone number invalid`)
              .test("range", "Phone number invalid", (val) => {
                const numberedVal = Number(val);
                if (!isNaN(numberedVal)) {
                  if (numberedVal > 2000000000 && numberedVal < 9999999999)
                    return true;
                }
                return false;
              }),
            is_preferred: yup
              .boolean()
              .default(false)
              .required("Preferred phone is required"),
            is_ok_to_leave_message: yup
              .boolean()
              .default(false)
              .required("OK to leave message is required"),
            id: yup.number().required().nullable(),
          }),
        )
        .min(1, "At least one phone number is required for patient")
        .required(`at least one phone number is required for patient`),

      address: yup
        .object({
          street: yup
            .string()
            .required(`Street is required`)
            .test(
              "whiteSpaceRemoval",
              "Street should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
          suite: yup.string().when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Suite should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
          city: yup
            .string()
            .required(`City is required`)
            .test(
              "whiteSpaceRemoval",
              "City should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
          state: yup.string().required(`State is required`),
          zip: yup
            .string()
            .required(`Zip is required`)
            .max(9, "Zip should not be more than 9 digits")
            .test(
              "containAllDigits",
              "Zip should only contain digits",
              (val) => (val ? /^\d+$/.test(val) : false),
            ),
          address_name: yup.string().required(`Address type is required`),
        })
        .required(`Address for patient information is required`),
    })
    .required(`Patient details are required`),

  doctor_attributes: yup.object({
    practice_id: yup
      .number()
      .typeError(`Practice is required`)
      .moreThan(0, `Practice is required`)
      .required(`Practice is required`),
    global_doctor_id: yup
      .number()
      .typeError(`Administrative prescriber is required`)
      .moreThan(0, `Administrative prescriber is required`)
      .required(`Administrative prescriber is required`),
  })
    .required(`Provider details are required`),

  // shipments_attributes: yup.array().of(
  //   yup.object({
  //     ship_to_street: yup.string(),
  //     ship_to_suite: yup.string(),
  //     ship_to_city: yup.string(),
  //     ship_to_state: yup.string(),
  //     ship_to_zip: yup.string(),
  //   }),
  // )
  // //.required(`shipment attributes are required`)
  // ,

  insurances_attributes: yup
    .array()
    .of(
      yup.object({
        insurance_name: yup
          .string()
          .required(`Insurance Name is required`)
          .test(
            "whiteSpaceRemoval",
            "Insurance Name should not contain only spaces",
            (val) => spaceCheckYupValidation(val),
          ),
        relation_to_patient: yup
          .string()
          .required(`Relation to patient is required`),
        relation_firstname: yup
          .string()
          .max(35, "First name should only be 35 characters long")
          .when("relation_to_patient", {
            is: (relation: string) => relation && relation !== "self",
            then: (schema) => schema.required("First name is required"),
          })
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "First name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        relation_middlename: yup
          .string()
          .max(35, "Middle name should only be 35 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Middle name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        relation_lastname: yup
          .string()
          .max(35, "Last name should only be 35 characters long")
          .when("relation_to_patient", {
            is: (relation: string) => relation && relation !== "self",
            then: (schema) => schema.required("Last name is required"),
          })
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Last name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),

        policy: yup.string(),
        //.required(`Member id is required`)
        group_number: yup
          .string()
          .max(45, "Group should only be 45 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Group should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        insurance_number: yup.string().when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema
              .min(10, `Insurance phone number invalid`)
              .max(10, `Insurance phone number invalid`)
              .test("range", "Insurance phone number invalid", (val) => {
                const numberedVal = Number(val);
                if (!isNaN(numberedVal)) {
                  if (numberedVal > 2000000000 && numberedVal < 9999999999)
                    return true;
                }
                return false;
              }),
        }),

        member_id: yup
          .string()
          .max(55, "Member id should only be 55 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Member id should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          })
          .required(`RX Member id is required`),
        bin: yup.string().when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema
              .max(6, "bin should be 6 digits long")
              .test(
                "containAllDigits",
                "bin should only contain digits",
                (val) => spaceCheckYupValidation(val),
              ),
        }),
        pcn: yup
          .string()
          .max(45, "PCN should only be 45 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "PCN should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        rx_group: yup
          .string()
          .max(45, "Rx group should only be 45 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Rx group should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),

        is_primary_insurance: yup.boolean().required(),
        insurance_priority: yup.number().required(),
        global_insurance_id: yup.string().required().nullable(),
      }),
    )
    .min(1, "At least one insurance information is required")
    .required("Patient insurance information is required"),

  case_attributes: yup.object({
    // ship_to: yup.string(),
    pa_approved: yup.string(),
    pa_approved_date: yup.string().when(["pa_approved"], {
      is: (pa_approved?: string) => {
        return pa_approved &&
          pa_approved === "pa_approved" &&
          process.env.REACT_APP_ENV === "staging"
          ? true
          : false;
      },
      then: (schema) => schema.required("Approval end date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    //.test("whiteSpaceRemoval", "Site of Care should not contain only spaces", (val) => spaceCheckYupValidation(val)),
  }),
  //.required(`Site of care is required`),
});
